<template>
  <div>
    <b-card title="MiME Internet Services">
      <b-table
        responsive
        :items="ispServices"
        :fields="fields"
        show-empty
        empty-text="No ISP service found"
      >
        <!-- SL / Index -->
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>

        <!-- Service Type -->
        <template #cell(service_line_type)="data">
          {{ data.item.service_line_type }}
        </template>

         <!-- Service Type -->
        <template #cell(service_name)>
          MiME Internet
        </template>

        <!-- Package Name -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Package Price -->
        <template #cell(sub_total)="data">
          {{ data.item.service_line_type !== "Bundle" ? data.item.sub_total + " tk" : "-" }}
        </template>

        <!-- Real IP -->
        <template #cell(isp_real_ip_address)="data">
          {{ data.item.isp_real_ip_address || "-" }}
        </template>

        <!-- Discount -->
        <template #cell(discount)="data">
          {{ data.item.discount }}
        </template>

        <!-- Valid From -->
        <template #cell(start_date_time)="data">
          {{ data.item.start_date_time }}
        </template>

        <!-- Valid To -->
        <template #cell(end_date_time)="data">
          {{ data.item.end_date_time }}
        </template>

        <!-- Bandwidth -->
        <template #cell(package_bandwidth)="data">
          {{ data.item.package_bandwidth }}
        </template>

        <!-- Status -->
        <template #cell(status)="data">
          <b-badge :variant="data.item.status ? 'success' : 'danger'">
            {{ data.item.status ? "Active" : "Inactive" }}
          </b-badge>
        </template>

        <!-- Billable -->
        <template #cell(billable)="data">
          <b-badge :variant="data.item.billable ? 'success' : 'danger'">
            {{ data.item.billable ? "Active" : "Inactive" }}
          </b-badge>
        </template>

        <!-- Action / Resend Password -->
        <template #cell(action)="data">
          <b-button size="sm" variant="info" @click="openResendModal(data.item)">
            Resend Password
          </b-button>
        </template>

        <!-- Info / Modal -->
        <template #cell(info)="data">
          <b-button size="sm" :style="{ width: '100px', marginBottom: '5px' }" variant="primary" @click="showModal(data.item)">
            Info
          </b-button>
          <b-button size="sm" :style="{ width: '100px' }" variant="secondary" @click="showGraphDataModal(data.item)">
            Graph
          </b-button>
        </template>
      </b-table>

       <!-- Modal for User Info -->
      <b-modal v-model="modalVisible" title="User Info" size="lg" 
      hide-footer
      no-close-on-backdrop
      no-close-on-esc>
        <table class="table table-bordered">
          <tr>
            <td>Live Status</td>
            <td>
              <img
                :src="modalData.live_status === 'Online' ? '/images/online.png' : '/images/offline.png'"
                class="brand-image"
              />
            </td>
          </tr>
          <tr>
            <td>Online Time</td>
            <td>
              {{ formatOnlineTime(modalData.latest_session ? modalData.latest_session.acctsessiontime : 0) }}
            </td>
          </tr>
          <tr>
            <td>BW Upload</td>
            <td>
              {{ modalData.latest_session_status && modalData.latest_session ? roundMB(modalData.latest_session.acctinputoctets) : "-" }} MB
            </td>
          </tr>
          <tr>
            <td>BW Download</td>
            <td>
              {{ modalData.latest_session_status && modalData.latest_session ? roundMB(modalData.latest_session.acctoutputoctets) : "-" }} MB
            </td>
          </tr>
          <tr>
            <td>Installation Address</td>
            <td>{{ modalData.installment_address || "-" }}</td>
          </tr>
        </table>
      </b-modal>

      <!-- Confirmation Modal -->
      <b-modal
        v-model="resendModalVisible"
        title="Confirm Resend"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <p>
          Are you sure you want to resend the password?
        </p>

        <div class="text-right">
          <b-button variant="secondary" class="mr-2" @click="resendModalVisible = false">
            No
          </b-button>

          <b-button variant="warning" @click="confirmResend"> Yes </b-button>
        </div>
      </b-modal>

      <b-modal
        v-model="showGraphModal"
        title="Bandwidth Usages Graph"
        size="lg"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        modal-class="showgraphmodal"
      >
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h5>Bandwidth Usages by Date (GB)</h5>

          <!-- Date Range -->
          <date-range-picker
            v-model="dateRange"
            :locale-data="{ format: 'DD/MM/YYYY', firstDay: 1 }"
            :opens="'right'"
            :auto-apply="false"
            :time-picker="false"
            @update="onDateChange"
          >
            <template v-slot:input="picker">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="formatDateRangeDisplay(picker.startDate, picker.endDate)"
                  readonly
                  placeholder="Select date range"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </template>
          </date-range-picker>
              

          <!-- Buttons -->
          <div>
            <b-button size="sm" :variant="chartType==='all'?'success':'outline-success'" @click="setChartType('all')">All</b-button>
            <b-button size="sm" :variant="chartType==='download'?'success':'outline-success'" @click="setChartType('download')">Download</b-button>
            <b-button size="sm" :variant="chartType==='upload'?'success':'outline-success'" @click="setChartType('upload')">Upload</b-button>
          </div>
        </div>

        <canvas ref="bandwidthChart" height="100"></canvas>

        <div class="text-center mt-2">
          Total: {{ totals.total }} GB,
          Download: {{ totals.download }} GB,
          Upload: {{ totals.upload }} GB
        </div>
      </b-modal>

    </b-card>
    <div class="row">
      <div class="col-12 col-lg-6">
        <b-card>
          <div class="md">
            <h3 class="mt-10">How to Pay for MiME Internet from Selfcare</h3>
            <video class="responsive-video" width="100%" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BTable, BBadge, BButton, BModal } from "bootstrap-vue";
import { Chart, registerables } from 'chart.js';
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import api from "@/services/api";
import { decrypt } from "@/utils/crypto";

// Register all Chart.js components
Chart.register(...registerables);

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BButton,
    BModal,
    DateRangePicker 
  },
  data() {
    return {
      serviceLines: [],
      resendPassword: {
        id: null,
        customer_id: null,
        isp_username: null,
        isp_password: null,
      },
      videoUrl: "/documents/How_to_Pay_for_MiME_Internet_from_Selfcare.mp4",
      showGraphModal: false,
      chart: null,
      chartType: "all",
      resendModalVisible: false,

      labels: [],
      datasets: {
        all: [],
        download: [],
        upload: [],
      },

      totals: {
        total: 0,
        download: 0,
        upload: 0,
      },

      // ✅ Date range
      dateRange: {
        startDate: moment(),
        endDate: moment(),
      },

      selectedItem: null, // store clicked row

      modalVisible: false,
      modalData: {},
      fields: [
        { key: "sl", label: "#" },
        { key: "service_line_type", label: "Service Type" },
        { key: "service_name", label: "Service Name" },
        { key: "name", label: "Package Name" },
        { key: "sub_total", label: "Package Price" },
        { key: "isp_real_ip_address", label: "Real IP" },
        { key: "discount", label: "Discount" },
        { key: "start_date_time", label: "Valid From" },
        { key: "end_date_time", label: "Valid To" },
        { key: "package_bandwidth", label: "Bandwidth" },
        { key: "status", label: "Status" },
        { key: "billable", label: "Billable" },
        { key: "action", label: "Action" },
        { key: "info", label: "Info" },
      ],
    };
  },

  computed: {
    // Only ISP services
    ispServices() {
      return this.serviceLines.filter((service) => service.service_type === "isp");
    },
  },

  methods: {
    formatDateRangeDisplay(startDate, endDate) {
      if (!startDate || !endDate) return "";
      return `${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`;
    },

    roundMB(bytes) {
      if (!bytes) return 0;
      return (bytes / (1024 * 1024)).toFixed(2);
    },

    async fetchServiceLines() {
      const userData = decrypt(localStorage.getItem("userData"));
      const username = userData?.username;
      const loader = this.$showCustomLoader();
      
      try {
        const res = await api.get(
          `/selfcare/api/v1/customer/service-line/?username=${username}`
        );
        loader?.hide();
        this.serviceLines = res.data.package_line || [];
      } catch (error) {
        console.error("Service line fetch failed:", error);
        loader?.hide();
      }
    },

    formatOnlineTime(seconds) {
      if (!seconds) return "-";
      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds / 60) % 60);
      const secs = seconds % 60;
      if (hrs > 0) return `${hrs} hours, ${mins} minutes`;
      if (mins > 0) return `${mins} minutes, ${secs} seconds`;
      return `${secs} seconds`;
    },

    openResendModal(item) {
      this.resendPassword.id = item.id;
      this.resendPassword.customer_id = item.customer_id;
      this.resendPassword.isp_username = item.isp_username;
      this.resendPassword.isp_password = item.isp_password;
      this.resendModalVisible = true;
    },

    // Confirm resend action
    async confirmResend() {
      const loader = this.$showCustomLoader();

      try {
        await api.post(
          "/api/v1/isp_password_resend/",
          this.resendPassword
        );

        this.$bvToast.toast("Password resent successfully", {
          title: "Success",
          variant: "success",
          solid: true,
        });

        this.resendModalVisible = false;
      } catch (error) {
        console.error("Resend password failed", error);

        this.$bvToast.toast("Failed to resend password", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        loader.hide();
      }
    },

    showModal(item) {
      this.modalData = item;
      this.modalVisible = true;
    },

    async showGraphDataModal(item) {
      this.showGraphModal = true;
      this.selectedItem = item;

      await this.fetchGraphData();
    },

    async fetchGraphData() {
      const payload = {
        isp_username: this.selectedItem.isp_username,
        date_range_start: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        date_range_end: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
      };

      try {
        const res = await api.post("/api/isp/bandwidth_usages_graph_data/", payload);

        this.labels = res.data.big_line_chart_label[0];

        this.datasets.all = res.data.big_line_chart_value[0];
        this.datasets.download = res.data.big_line_chart_value[1];
        this.datasets.upload = res.data.big_line_chart_value[2];

        this.totals.total = res.data.total_up_down;
        this.totals.download = res.data.total_down;
        this.totals.upload = res.data.total_up;

        // ✅ PLACE IT HERE
        this.$nextTick(() => {
          setTimeout(() => {
            this.renderChart();
          }, 300);
        });

      } catch (err) {
        console.error(err);
      }
    },
    
    onDateChange() {
      this.fetchGraphData();
    },

    setChartType(type) {
      this.chartType = type;
      this.renderChart();
    },

    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.bandwidthChart;

      let data = [];

      if (this.chartType === "all") {
        data = this.datasets.all;
      } else if (this.chartType === "download") {
        data = this.datasets.download;
      } else {
        data = this.datasets.upload;
      }

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.labels,
          datasets: [
            {
              label: "Bandwidth (GB)",
              data: data,
              borderColor: "blue",
              backgroundColor: "rgba(0,0,255,0.1)",
              tension: 0.4,
              fill: true,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    },
  
  },

  mounted() {
    this.fetchServiceLines();
  },
};
</script>

<style scoped>
.date-range-wrapper {
  min-width: 280px;
}

.date-range-wrapper .input-group {
  cursor: pointer;
}

.date-range-wrapper .input-group-text {
  background-color: #e9ecef;
  border-left: none;
}

.date-range-wrapper .form-control {
  background-color: white;
  cursor: pointer;
}

.vue-daterange-picker > .form-control {
    padding: 0 !important;
}

.input-group > .form-control {
      width: 100%!important;
}

.form-control.reportrange-text {
    padding: 0 !important;
}

.date-range-wrapper .form-control:read-only {
  background-color: white;
}


.vue-daterange-picker >>> .reportrange-text {
    padding: 0 !important; /* remove padding */
    background-color: white; /* optional */
    border: 1px solid #ccc;
    cursor: pointer;
}

/* OR using /deep/ */
.vue-daterange-picker /deep/ .reportrange-text {
    padding: 0 !important;
}

.responsive-video {
  width: 100%;
  height: auto;
  max-width: 100%;
}

</style>